const tagToWord = (word) => {
    // convert tag such as test-tag to Test Tag

    return word
        .split('-')
        .map((tag) => tag.charAt(0).toUpperCase() + tag.substring(1))
        .join(' ').replace('And', '&');
}

export default tagToWord